import * as React from "react";

import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import SideBar from "../../SideBar";
import { FaArrowLeft } from "react-icons/fa";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import { API_URL } from "../../../../api";
import RedStar from "../../../common/RedStar";
export default function MedicineUpdate() {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [category, setCategory] = useState("");

  const [subCategory, setSubCategory] = useState("");
  const [upCat, setUpCat] = useState("");
  const [upSubCat, setUpSubCat] = useState("");

  const [categoryID, setCategoryID] = useState("");
  const [subCategoryID, setSubCategoryID] = useState("");
  console.log(categoryID);
  const [categoryLists, setCategoryLists] = useState([]);
  const [subCategoryLists, setSubCategoryLists] = useState([]);

  const [medicineLists, setMedicineLists] = useState([]);
  const [relatedBrandList, setRelatedBrandList] = useState([]);
  const [upRelatedBrand, setUpRelatedBrand] = useState("");
  const [upCode, setUpCode] = useState("");
  const [upName, setUpName] = useState("");
  const [upDesc, setUpDesc] = useState("");
  const [showUpdate, setShowUpdate] = useState(false);
  const [upRelatedBrandID, setUpRelatedBrandID] = useState("");

  const [description, setDescription] = useState("");

  const [isLoading, setIsLoading] = useState(true);

  const [errors, setErrors] = useState({
    upCode: "",
    upName: "",
    categoryID: "",
    subCategoryID: "",
    upRelatedBrandID: "",
  });

  const ProId = useLocation().pathname.split("/")[2];

  const MedicineUpdate = () => {
    const require = {};
    if (!upCode) {
      require.upCode = "This field is required";
    }
    if (!upName) {
      require.upName = "This field is required";
    }
    if (!categoryID) {
      require.categoryID = "This field is required";
    }
    if (!subCategoryID) {
      require.subCategoryID = "This field is required";
    }
    if (!upRelatedBrandID) {
      require.upRelatedBrandID = "This field is required";
    }
    if (Object.keys(require).length > 0) {
      setErrors(require);
      return;
    }

    setIsLoading(true);

    setErrors({
      upCode: "",
      upName: "",
      categoryID: "",
      subCategoryID: "",
      upRelatedBrandID: "",
    });

    const data = {
      id: ProId,
      name: upName,
      code: upCode,
      //   relatedBrand: upRelatedBrand,
      description: upDesc,
    };
    //brand
    if (upRelatedBrandID) {
      data.relatedBrand = upRelatedBrandID;
    } else {
      data.relatedBrand = upRelatedBrand;
    }
    //category

    if (categoryID) {
      data.relatedCategory = categoryID;
    } else {
      data.relatedCategory = category;
    }

    //sub category
    if (subCategoryID) {
      data.relatedSubCategory = subCategoryID;
    } else {
      data.relatedSubCategory = subCategory;
    }

    // alert(JSON.stringify(data))
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("procedure-medicine", data, config)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "You Created Income Data!",
          icon: "success",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
        // window.location.reload()

        // setMedicineLists([...medicineLists, response.data.list[0]])
        setMedicineLists(
          medicineLists.map((category) => {
            if (category._id === response.data.list[0]._id) {
              return response.data.list[0];
            } else {
              return category;
            }
          }),
        );

        setIsLoading(false);
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };

  useEffect(() => {
    const getCategory = async () => {
      try {
        const res = await api.get("categories");

        setCategoryLists(res.data.data);
      } catch (err) {}
    };
    const getSubCategory = async () => {
      try {
        const res = await api.get("sub-categories");

        setSubCategoryLists(res.data.data);
      } catch (err) {}
    };

    const getBrandLists = async () => {
      try {
        const res = await api.get("brands");
        setRelatedBrandList(res.data.data);
      } catch (err) {
        alert(err.message);
      }
    };

    const getProMedicine = async () => {
      try {
        setIsLoading(true);
        const res = await api.get("procedure-medicine/" + ProId);
        setUpCode(res.data.data[0].code);
        setUpName(res.data.data[0].name);
        setUpDesc(res.data.data[0].description);
        setUpRelatedBrand(res.data.data[0].relatedBrand?.name);
        setUpRelatedBrandID(res.data.data[0].relatedBrand?._id);
        setUpCat(res.data.data[0].relatedCategory?.name);
        setCategoryID(res.data.data[0].relatedCategory?._id);
        setUpSubCat(res.data.data[0].relatedSubCategory?.name);
        setSubCategoryID(res.data.data[0].relatedSubCategory?._id);
        setIsLoading(false);
      } catch (err) {
        alert(err.message);
      }
    };

    getCategory();
    getSubCategory();

    getProMedicine();
    getBrandLists();
  }, []);
  return (
    <div classNameName="App">
      {/* <!-- end preloader --> */}
      {/* @include('sweet::alert') */}

      <div className="wrapper">
        <div>
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/pro_medicine">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Procedure Medicine Update
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className="content" style={{ paddingBottom: "1.5rem" }}>
            <div className="container-fluid px-4">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="col-md-12">
                        <h3 className="card-header mb-4 fw-5 text-secondary py-3">
                          Update Procedure Medicine
                        </h3>
                        <div class="modal-body">
                          <div class="form-group">
                            <label for="code">
                              Code <RedStar />
                            </label>
                            <input
                              type="text"
                              class="form-control border border-info"
                              name="code"
                              value={upCode}
                              onChange={(e) => setUpCode(e.target.value)}
                            />
                            {errors?.upCode && (
                              <div className="text-danger">
                                {errors?.upCode}
                              </div>
                            )}
                          </div>
                          <div class="form-group">
                            <label for="name">
                              Name <RedStar />
                            </label>
                            <input
                              type="text"
                              class="form-control border border-info"
                              name="name"
                              value={upName}
                              onChange={(e) => setUpName(e.target.value)}
                            />
                            {errors?.upName && (
                              <div className="text-danger">
                                {errors?.upName}
                              </div>
                            )}
                          </div>
                          <div class="form-group">
                            <label for="name">
                              Category <RedStar />
                            </label>
                            <select
                              class="custom-select border-info"
                              name="account_type_id"
                              id="cat"
                              onChange={(e) => {
                                setCategory(e.target.value);
                                setCategoryID(e.target.value);
                              }}
                              value={categoryID}
                            >
                              <option value="" hidden>
                                Select Category
                              </option>
                              {categoryLists.map((option, i) => (
                                <option value={option._id} key={i}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                            {errors?.categoryID && (
                              <div className="text-danger">
                                {errors?.categoryID}
                              </div>
                            )}
                          </div>
                          <div class="form-group">
                            <label for="name">
                              Sub Category <RedStar />
                            </label>
                            <select
                              class="custom-select border-info"
                              id="subCat"
                              name="account_type_id"
                              onChange={(e) => {
                                setSubCategory(e.target.value);
                                setSubCategoryID(e.target.value);
                              }}
                              value={subCategoryID}
                            >
                              <option value="" hidden>
                                Select Sub Category
                              </option>
                              {subCategoryLists.map((option, i) => (
                                <option value={option._id} key={i}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                            {errors?.subCategoryID && (
                              <div className="text-danger">
                                {errors?.subCategoryID}
                              </div>
                            )}
                          </div>
                          <div class="form-group">
                            <label for="name">
                              Choose Brand <RedStar />
                            </label>
                            <select
                              name="currency"
                              id=""
                              className="form-control mt-1"
                              onchange="convert(this.value)"
                              onChange={(e) => {
                                setUpRelatedBrand(e.target.value);
                                setUpRelatedBrandID(e.target.value);
                              }}
                              value={upRelatedBrandID}
                            >
                              <option value="" hidden>
                                Select Brand
                              </option>

                              {relatedBrandList.map((option, i) => (
                                <option value={option._id} key={i}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                            {errors?.upRelatedBrandID && (
                              <div className="text-danger">
                                {errors?.upRelatedBrandID}
                              </div>
                            )}
                          </div>
                          <div class="form-group">
                            <label for="name">Description</label>
                            <textarea
                              className="form-control"
                              id="description"
                              defaultValue={upDesc}
                              onChange={(e) => setUpDesc(e.target.value)}
                            ></textarea>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <Link
                            to="/medicine_list"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                          >
                            Close
                          </Link>
                          <button
                            class="btn btn-primary"
                            onClick={MedicineUpdate}
                            disabled={isLoading}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*<!-- /.container-fluid --> */}
          </section>
        </div>
      </div>

      {/* <!-- /.content-wrapper --> */}
    </div>
  );
}
